import type { UpdateLabelRequest, UpdateLabelResponse } from '@vy/api-definition';
import { UpdateLabelResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

type UseUpdateLabelVariables = {
  labelId: string;
  updateLabelRequest: UpdateLabelRequest;
};

export function useUpdateLabel(
  options?: UseMutationOptions<UpdateLabelResponse, unknown, UseUpdateLabelVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ labelId, updateLabelRequest }) => {
      const api = getPrivateApi();
      const response = await api.updateLabel({
        labelId,
        updateLabelRequest,
      });

      return UpdateLabelResponseSchema.parse(response);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [queryKeys.labels()],
        });
      },
      ...options,
    },
  );
}
